<ng-select class="sd-picker" appendTo="body" [labelForId]="labelForId" [class.is-invalid]="invalid"
           [items]="options" bindValue="id" bindLabel="name" [searchFn]="match"
           [ngModel]="value" (ngModelChange)="onChange($event)"
           [loading]="loading" loadingText="Loading people…" notFoundText="No one matches"
           [placeholder]="placeholder" [clearable]="false">
  <ng-template ng-label-tmp let-item="item">
    <span class="pp-value">
      <span class="pp-avatar pp-avatar--sm" [class.pp-avatar--role]="item.isRole">{{ item.isRole ? '★' : (item.name | shortLogo) }}</span>
      <span class="pp-value__name">{{ item.name }}</span>
    </span>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <span class="sd-picker-option">
      <span class="sd-picker-option__icon pp-avatar" [class.pp-avatar--role]="item.isRole" aria-hidden="true">
        {{ item.isRole ? '★' : (item.name | shortLogo) }}
      </span>
      <span class="sd-picker-option__text">
        <span class="sd-picker-option__title">{{ item.name }}</span>
        <span class="sd-picker-option__sub">{{ item.isRole ? 'Whoever gets to it first' : item.email }}</span>
      </span>
    </span>
  </ng-template>
</ng-select>
